import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "form-group col-sm-12 col-md-12 my-3" }
const _hoisted_4 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_5 = { class: "form-group col-sm-12 col-md-12 my-3" }
const _hoisted_6 = {
  for: "name",
  class: "control-label me-3"
}
const _hoisted_7 = { class: "form-group col-sm-12 col-md-12 my-3" }
const _hoisted_8 = {
  for: "name",
  class: "control-label me-3"
}
const _hoisted_9 = { class: "form-group col-sm-12 col-md-12 my-3" }
const _hoisted_10 = {
  for: "mail",
  class: "control-label me-3"
}
const _hoisted_11 = { class: "form-group col-sm-12 col-md-12 my-3" }
const _hoisted_12 = {
  for: "password",
  class: "control-label me-3"
}
const _hoisted_13 = ["placeholder"]

import { ref } from 'vue'
import { useRouter } from 'vue-router';
import { UsersService } from '../../biz/remote/UsersService';
import { MessageDialog } from '../../../framework/frontend/MessageDialog';
import { SessionUser } from '../../utils/SessionUser';
import CoreDialog from '../../../framework/components/dialog/CoreDialog.vue';
import { DialogHandler } from './DialogHandler';
import { translation } from '../../lang/Translation';


export default /*#__PURE__*/_defineComponent({
  __name: 'DelUserDialog',
  setup(__props) {

const t = translation;
/**
 * 動的ラベル
 */
const router = useRouter();
const password = ref('');
const dialogId = DialogHandler.delUserDialogId;
const title_unsubscribed = t.to("退会手続きをします。一度退会するとこれまでに作成した作品は利用できなくなります。","title_unsubscribed")

const updateDB = async () => {
  if (MessageDialog.confirm(t.to('退会してよろしいですか？',"confirm_unscribe_user"))) {
    const biz = new UsersService();
    const response = await biz.userDel(SessionUser.instance.userId, password.value);
    if (response.hasError) {
      MessageDialog.alert(response.errorDescription);
      return;
    }
    MessageDialog.alert(t.to(`退会しました`,"done_unscribe_user" ));
    // サインアウト処理
    sessionStorage.clear();
    DialogHandler.hideDialog(DialogHandler.delUserDialogId);
    router.push('/');
  }
};

const user_id = ref(0);
const mail = ref('');
const username = ref('');

const biz = new UsersService();
biz.getUser(SessionUser.instance.userId).then((response) => {
  const user = response.data;
  user_id.value = user.user_id;
  mail.value = user.mail;
  username.value = user.name;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, { id: _unref(dialogId) }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-danger",
        onClick: updateDB
      }, _toDisplayString(_unref(t).to("退会","unsubscribe")), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(title_unsubscribed)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t).to("ユーザーID","user_id")), 1),
            _createElementVNode("span", null, _toDisplayString(user_id.value), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t).to("氏名","user_name")), 1),
            _createElementVNode("span", null, _toDisplayString(username.value), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t).to("メールアドレス","email")), 1),
            _createElementVNode("span", null, _toDisplayString(mail.value), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t).to("パスワード","password")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
              type: "password",
              class: "form-control",
              placeholder: _unref(t).to(`パスワード`,`password`),
              required: ""
            }, null, 8, _hoisted_13), [
              [_vModelText, password.value]
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})